import { useRef, useState, useEffect, useCallback, forwardRef } from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Text from './Text';
import Form, { Field } from 'rc-field-form';
import TextField from '@mui/material/TextField';
import { useTranslation } from "react-i18next";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { withStyles } from '@mui/material/styles'

import IconButton from '@mui/material/IconButton';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { createTheme } from '@mui/material/styles';

export default function AppButton({ id, text, val, callback, error, color, type = "string" }) {

  const { t } = useTranslation();

  const theme = createTheme({
    components: {

      MuiTextField: {
        styleOverrides: {
          root: {
            '& label': {
              color: color,
            },
            '& label.Mui-focused': {
              color: color,
            },

          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            textTransform: 'initial',
            fontSize: '1rem',
          },
        },
      },
    },
  });

  return (

    <Button 
      variant="contained" 
      color="green" 
      className="input"
      disableElevation
      onClick={callback}
      sx={{
        color: '#f6ffda',
        fontWeight: 500
      }}>
        <span className="button">{t("formular_send")}</span>
      </Button>

  )
}

